import { tSettingOptionSchema } from '@app/pages/profiles/profile-details/profile-ide-provisioner/schemas/setting-option-schema';
export const tAutoinstalledToolsSchema = tSettingOptionSchema;
